<template>
  <div class="wraps">
    <div class="list list__desktop" @click="handleCheck">
      <div class="list__check">
        <svg
          :class="{ select: order.checked }"
          width="25"
          height="24"
          viewBox="0 0 25 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.5008 13.6L16.4008 7.70005C16.5841 7.51672 16.8174 7.42505 17.1008 7.42505C17.3841 7.42505 17.6174 7.51672 17.8008 7.70005C17.9841 7.88338 18.0758 8.11671 18.0758 8.40005C18.0758 8.68338 17.9841 8.91672 17.8008 9.10005L11.2008 15.7C11.0008 15.9 10.7674 16 10.5008 16C10.2341 16 10.0008 15.9 9.80078 15.7L7.20078 13.1C7.01745 12.9167 6.92578 12.6834 6.92578 12.4C6.92578 12.1167 7.01745 11.8834 7.20078 11.7C7.38411 11.5167 7.61745 11.425 7.90078 11.425C8.18411 11.425 8.41745 11.5167 8.60078 11.7L10.5008 13.6Z"
          />
        </svg>
      </div>
      <div class="list__pin">
        <div class="list__pin--info departure">
          <div class="list__name">
            <span
              >{{ order.pins[0].name }} ({{ order.pins[0].phoneNumber }})</span
            >
          </div>
          <div class="list__date">
            <orderTag
              v-if="
                order.deliveryOptions.isReserved ||
                order.deliveryOptions.isReserved === undefined
              "
              status="reserved"
            ></orderTag>
            <span
              v-if="
                order.deliveryOptions.isReserved ||
                order.deliveryOptions.isReserved === undefined
              "
            >
              {{ $utcToLocal(order.pins[0].pickupDate, "M/D") }} ({{
                order.pins[0].pickupDate | utcGetDay
              }}) {{ order.pins[0].pickupHour }}:{{
                order.pins[0].pickupMinute
              }}
              픽업
            </span>
            <span v-else>즉시 픽업</span>
          </div>
          <div class="list__address">
            {{ order.pins[0].roadAddress
            }}<span v-if="order.pins[0].detailAddress !== ''"
              >,{{ order.pins[0].detailAddress }}</span
            >
          </div>
        </div>
        <div class="destination list__pin--info">
          <div class="list__name">
            <span
              >{{ order.pins[order.pins.length - 1].name }} ({{
                order.pins[order.pins.length - 1].phoneNumber
              }})</span
            >
          </div>
          <div
            class="list__date"
            v-if="order.deliveryOptions.isExpressDelivery"
          >
            <orderTag status="express"></orderTag>
            {{
              mixinsEstimatedTime(
                order.deliveryOptions.isReserved
                  ? order.deliveryOptions.reserveExpressEstimatedMinutes
                  : order.deliveryOptions.expressEstimatedMinutes
              )
            }}
          </div>
          <div class="list__date" v-else>
            {{
              mixinsEstimatedTime(
                order.deliveryOptions.isReserved
                  ? order.deliveryOptions.reserveEstimatedMinutes
                  : order.deliveryOptions.estimatedMinutes
              )
            }}
          </div>
          <div class="list__address">
            {{ order.pins[order.pins.length - 1].roadAddress
            }}<span
              v-if="order.pins[order.pins.length - 1].detailAddress !== ''"
              >,{{ order.pins[order.pins.length - 1].detailAddress }}</span
            >
          </div>
        </div>
      </div>
      <div class="list__info">
        <div class="list__deliveryOption">
          <img
            :src="
              filterVehicleCategoryImage(
                vehicles,
                order.deliveryOptions.vehicleCategory
              )
            "
          />
          <div>
            {{
              filterVehicleCategory(
                vehicles,
                order.deliveryOptions.vehicleCategory
              )
            }}
          </div>
        </div>
        <div>
          <div class="list__deliveryOption">
            <img
              v-if="
                checkItems(order.deliveryOptions.item).imgKey === 'document'
              "
              src="@/assets/img/order/document.png"
            />
            <img
              v-if="
                checkItems(order.deliveryOptions.item).imgKey === 'smallBox'
              "
              src="@/assets/img/order/small_box.png"
            />
            <img
              v-if="checkItems(order.deliveryOptions.item).imgKey === 'bigBox'"
              src="@/assets/img/order/big_box.png"
            />
            <img
              v-if="checkItems(order.deliveryOptions.item).imgKey === 'etc'"
              src="@/assets/img/order/etc.png"
            />
            <img
              v-if="checkItems(order.deliveryOptions.item).imgKey === 'several'"
              src="@/assets/img/order/several.png"
            />
            <div>{{ checkItems(order.deliveryOptions.item).title }}</div>
          </div>
        </div>
        <div class="list__price">
          {{ order.deliveryOptions.totalOrderFee.toLocaleString() }}원
        </div>
      </div>
      <div class="list-control">
        <div
          class="list-control__btn list-control__btn--modify"
          @click.stop="editOrder()"
        >
          수정
        </div>
        <div
          @click.stop="isDetailOpen = !isDetailOpen"
          class="list-control__btn list-control__btn--detail"
        >
          상세보기
        </div>
      </div>
    </div>
    <div class="list list__mobile" @click="handleCheck">
      <div class="list__check">
        <svg
          :class="{ select: order.checked }"
          width="25"
          height="24"
          viewBox="0 0 25 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.5008 13.6L16.4008 7.70005C16.5841 7.51672 16.8174 7.42505 17.1008 7.42505C17.3841 7.42505 17.6174 7.51672 17.8008 7.70005C17.9841 7.88338 18.0758 8.11671 18.0758 8.40005C18.0758 8.68338 17.9841 8.91672 17.8008 9.10005L11.2008 15.7C11.0008 15.9 10.7674 16 10.5008 16C10.2341 16 10.0008 15.9 9.80078 15.7L7.20078 13.1C7.01745 12.9167 6.92578 12.6834 6.92578 12.4C6.92578 12.1167 7.01745 11.8834 7.20078 11.7C7.38411 11.5167 7.61745 11.425 7.90078 11.425C8.18411 11.425 8.41745 11.5167 8.60078 11.7L10.5008 13.6Z"
          />
        </svg>
        <span class="list__price"
          >{{ order.deliveryOptions.totalOrderFee.toLocaleString() }}원</span
        >
      </div>
      <div class="list__pin">
        <div class="list__option--circle-top">
          <div class="circle circle__top"></div>
          <div>
            <div class="list__name">
              <span
                >{{ order.pins[0].name }} ({{
                  order.pins[0].phoneNumber
                }})</span
              >
            </div>
            <div class="list__date">
              <orderTag
                v-if="
                  order.deliveryOptions.isReserved ||
                  order.deliveryOptions.isReserved === undefined
                "
                status="reserved"
              ></orderTag>
              <span
                v-if="
                  order.deliveryOptions.isReserved ||
                  order.deliveryOptions.isReserved === undefined
                "
              >
                {{ $utcToLocal(order.pins[0].pickupDate, "M/D") }} ({{
                  order.pins[0].pickupDate | utcGetDay
                }}) {{ order.pins[0].pickupHour }}:{{
                  order.pins[0].pickupMinute
                }}
                픽업
              </span>
              <span v-else>즉시 픽업</span>
            </div>
          </div>
        </div>
        <div class="list__option--circle-top">
          <div class="circle circle__full circle__top"></div>
          <div class="list__pin--subinfo">
            <div class="list__name">
              <span
                >{{ order.pins[order.pins.length - 1].name }} ({{
                  order.pins[order.pins.length - 1].phoneNumber
                }})</span
              >
            </div>

            <div
              class="list__date"
              v-if="order.deliveryOptions.isExpressDelivery"
            >
              <orderTag status="express"></orderTag>
              {{
                mixinsEstimatedTime(
                  order.deliveryOptions.isReserved
                    ? order.deliveryOptions.reserveExpressEstimatedMinutes
                    : order.deliveryOptions.expressEstimatedMinutes
                )
              }}
            </div>
            <div class="list__date" v-else>
              {{
                mixinsEstimatedTime(
                  order.deliveryOptions.isReserved
                    ? order.deliveryOptions.reserveEstimatedMinutes
                    : order.deliveryOptions.estimatedMinutes
                )
              }}
            </div>
          </div>
        </div>
      </div>
      <div class="list-control">
        <div
          @click="isDetailOpen = !isDetailOpen"
          class="list-control__btn list-control__btn--detail"
        >
          상세보기
        </div>
        <div
          class="list-control__btn list-control__btn--modify"
          @click="editOrder()"
        >
          수정
        </div>
      </div>
    </div>
    <div class="list__detail" v-if="isDetailOpen">
      <div class="list__option">
        <div class="list__option--row desktop">
          <div class="list__option--title list__option--circle">
            <div class="circle"></div>
            출발
          </div>
          <div>
            <div class="list__name">
              <span
                >{{ order.pins[0].name }} ({{
                  order.pins[0].phoneNumber
                }})</span
              >
            </div>
            <div
              class="list__date"
              v-if="
                order.deliveryOptions.isReserved ||
                order.deliveryOptions.isReserved === undefined
              "
            >
              <orderTag status="reserved"></orderTag>
              {{ $utcToLocal(order.pins[0].pickupDate, "M/D") }}
              ({{ order.pins[0].pickupDate | utcGetDay }})
              {{ order.pins[0].pickupHour }}:{{ order.pins[0].pickupMinute }}
              픽업
            </div>
            <div v-else class="list__date">즉시 픽업</div>
            <div class="list__address">
              {{ order.pins[0].roadAddress
              }}<span v-if="order.pins[0].detailAddress !== ''"
                >,{{ order.pins[0].detailAddress }}</span
              >
            </div>
            <div v-if="order.pins[0].pinMemo" class="list__memo">
              {{ order.pins[0].pinMemo }}
            </div>
          </div>
        </div>
        <div class="list__option--row mobile">
          <div class="list__option--title list__option--circle">
            <div class="circle"></div>
            출발
          </div>
          <div>
            <div
              class="list__date"
              v-if="
                order.deliveryOptions.isReserved ||
                order.deliveryOptions.isReserved === undefined
              "
            >
              <orderTag status="reserved"></orderTag>
              {{ $utcToLocal(order.pins[0].pickupDate, "M/D") }}
              ({{ order.pins[0].pickupDate | utcGetDay }})
              {{ order.pins[0].pickupHour }}:{{ order.pins[0].pickupMinute }}
              픽업
            </div>
            <div v-else class="list__date">즉시 픽업</div>
            <div class="list__name">
              <span
                >{{ order.pins[0].name }} ({{
                  order.pins[0].phoneNumber
                }})</span
              >
            </div>
            <div class="list__address">
              {{ order.pins[0].roadAddress
              }}<span v-if="order.pins[0].detailAddress !== ''"
                >,{{ order.pins[0].detailAddress }}</span
              >
            </div>
            <div v-if="order.pins[0].pinMemo" class="list__memo">
              {{ order.pins[0].pinMemo }}
            </div>
          </div>
        </div>
        <div
          v-if="waypointList.length > 0"
          class="list__waypoint"
          :class="{ 'list__waypoint--open': isWaypointOpen }"
        >
          <div
            class="list__waypoint--sub"
            @click="isWaypointOpen = !isWaypointOpen"
          >
            <span>경유지 {{ waypointList.length }}건</span>
            <img
              src="@/assets/img/order/dropdown.svg"
              :class="{ 'waypoint-dropdown': !isWaypointOpen }"
            />
          </div>
          <div v-if="isWaypointOpen" class="list__waypoint--detail">
            <div v-for="(list, idx) in waypointList">
              <div class="list__option--row list__option--waypoint">
                <div class="list__option--title list__option--circle">
                  <div class="circle"></div>
                  경유
                </div>
                <div class="list__info--waypoint">
                  <div class="list__name">
                    <span>{{ list.name }} ({{ list.phoneNumber }})</span>
                  </div>
                  <div class="list__address">
                    {{ list.roadAddress
                    }}<span v-if="list.detailAddress !== ''"
                      >,{{ list.detailAddress }}</span
                    >
                  </div>
                  <div v-if="list.pinMemo" class="list__memo">
                    {{ list.pinMemo }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="list__option--row">
          <div class="list__option--title list__option--circle">
            <div class="circle circle__full"></div>
            도착
          </div>
          <div>
            <div class="list__name">
              <span
                >{{ order.pins[order.pins.length - 1].name }} ({{
                  order.pins[order.pins.length - 1].phoneNumber
                }})</span
              >
            </div>

            <div
              class="list__date"
              v-if="order.deliveryOptions.isExpressDelivery"
            >
              <orderTag status="express"></orderTag>
              {{
                mixinsEstimatedTime(
                  order.deliveryOptions.isReserved
                    ? order.deliveryOptions.reserveExpressEstimatedMinutes
                    : order.deliveryOptions.expressEstimatedMinutes
                )
              }}
            </div>
            <div class="list__date" v-else>
              {{
                mixinsEstimatedTime(
                  order.deliveryOptions.isReserved
                    ? order.deliveryOptions.reserveEstimatedMinutes
                    : order.deliveryOptions.estimatedMinutes
                )
              }}
            </div>
            <div class="list__address">
              {{ order.pins[order.pins.length - 1].roadAddress
              }}<span
                v-if="order.pins[order.pins.length - 1].detailAddress !== ''"
                >,{{ order.pins[order.pins.length - 1].detailAddress }}</span
              >
            </div>
            <div
              v-if="order.pins[order.pins.length - 1].pinMemo"
              class="list__memo"
            >
              {{ order.pins[order.pins.length - 1].pinMemo }}
            </div>
          </div>
        </div>
      </div>
      <hr />

      <div class="list__option">
        <div class="list__option--row">
          <div class="list__option--title">배송수단</div>
          <div>
            {{
              filterVehicleCategory(
                vehicles,
                order.deliveryOptions.vehicleCategory
              )
            }}
            <span v-if="order.deliveryOptions.vehicleCategory === 8">
              ({{
                filterVehicleType(vehicles, order.deliveryOptions.vehicleType)
              }},
              {{
                filterVehicleOptions(
                  vehicles,
                  order.deliveryOptions.vehicleOption
                )
              }})
            </span>
          </div>
        </div>
        <div
          class="list__option--row"
          v-if="order.deliveryOptions.vehicleCategory === 8"
        >
          <div class="list__option--title">물품상세</div>
          <div>
            {{ order.deliveryOptions.item["etc"].content }}
          </div>
        </div>
        <div v-else class="list__option--row">
          <div class="list__option--title">물품상세</div>
          <div>
            {{ mergeItem(order.deliveryOptions.item) }} ({{
              order.deliveryOptions.weight
            }}kg 이하)
          </div>
        </div>
        <div
          class="list__option--row"
          v-if="order.deliveryOptions.vehicleCategory === 8"
        >
          <div class="list__option--title">상차옵션</div>
          <div>
            {{ filterPackage(vehicles, order.deliveryOptions.loadingPosition) }}
            <span v-if="order.deliveryOptions.loadingMethod !== null">
              |
              {{ filterPackage(vehicles, order.deliveryOptions.loadingMethod) }}
            </span>
          </div>
        </div>
        <div
          class="list__option--row"
          v-if="order.deliveryOptions.vehicleCategory === 8"
        >
          <div class="list__option--title">하차옵션</div>
          <div>
            {{
              filterPackage(vehicles, order.deliveryOptions.unloadingPosition)
            }}
            <span v-if="order.deliveryOptions.unloadingMethod !== null">
              |
              {{
                filterPackage(vehicles, order.deliveryOptions.unloadingMethod)
              }}
            </span>
          </div>
        </div>

        <div
          v-if="order.deliveryOptions.clientComment"
          class="list__option--row"
        >
          <div class="list__option--title">요청사항</div>
          <div>{{ order.deliveryOptions.clientComment }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import orderTag from "@/components/common/orderTag.vue";
import mixinFilter from "@/mixins/mixinFilter";
import mixinVehicle from "@/mixins/mixinVehicle";
export default {
  mixins: [mixinFilter, mixinVehicle],
  components: { orderTag },
  props: ["order", "idx", "vehicles"],
  created() {
    //경유지 리스트 생성
    if (this.order.pins.length > 2) {
      for (let i = 1; i < this.order.pins.length - 1; i++) {
        this.waypointList.push(this.order.pins[i]);
      }
    }
  },
  data() {
    return {
      isSelect: true,
      isDetailOpen: false,
      isWaypointOpen: false,
      waypointList: [],
      itemList: [
        {
          title: "서류",
          count: 0,
          value: "document",
          img: require("@/assets/img/order/document.png"),
        },
        {
          title: "소박스",
          description: "A4박스",
          count: 0,
          value: "smallBox",
          img: require("@/assets/img/order/small_box.png"),
        },
        {
          title: "대박스",
          description: "사과박스",
          count: 0,
          value: "bigBox",
          img: require("@/assets/img/order/big_box.png"),
        },
        {
          title: "기타",
          description: "꽃, 케잌 등",
          count: 0,
          value: "etc",
          img: require("@/assets/img/order/etc.png"),
        },
      ],
    };
  },
  methods: {
    handleCheck() {
      this.$emit("changeChecked");
    },
    editOrder() {
      const flag = "update";
      this.$router.push(`/orders/form/${this.idx}/${flag}`);
    },
    mergeItem(item) {
      const result = [];
      for (const key in item) {
        if (item[key].on) {
          if (key === "etc") {
            if (item[key].content !== null) {
              result.push(`${item[key].content}`);
            }
          } else if (item[key].number) {
            result.push(`${this.mixinsItemTitle(key)} ${item[key].number}개`);
          } else {
            if (item[key] > 0) {
              result.push(`${this.mixinsItemTitle(key)} ${item[key].number}개`);
            }
          }
        }
      }
      return result.join(", ");
    },
    checkItems(item) {
      let onCount = 0;
      let result = "";
      let imgKey = "";

      for (const key in item) {
        if (item.hasOwnProperty(key)) {
          if (item[key].on) {
            onCount++;
            if (onCount === 2) {
              imgKey = "several";
              return { title: "여러개", imgKey: imgKey };
            }
            if (key === "etc") {
              imgKey = key;
              result = `${this.mixinsItemTitle(key)}`;
            } else {
              imgKey = key;
              result = `${this.mixinsItemTitle(key)} ${item[key].number}개`;
            }
          }
        }
      }

      return { title: result, imgKey: imgKey };
    },

    getDeliveryOption() {
      const item = this.order.deliveryOptions.item;
      let count = 0;
      let resultKey = null;

      for (const key in item) {
        const value = item[key];

        if (typeof value === "number" && value >= 0) {
          count++;
        }
      }

      if (count >= 2) {
        resultKey = "many";
      } else {
        for (const key in item) {
          const value = item[key];

          if (value > 0) {
            resultKey = key;
          }
        }
      }
    },
  },
};
</script>
<style src="@/assets/css/newGlobal.css" scoped></style>
<style scoped src="./layout.css"></style>
